import { ComponentPropsWithoutRef } from 'react';

export default function VerticalDots(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      viewBox="0 0 30 60"
      preserveAspectRatio="xMidYMid meet"
      width="15"
      height="30"
      {...props}
    >
      <circle cx="15" cy="10" r="5" fill="#505166" />
      <circle cx="15" cy="30" r="5" fill="#505166" />
      <circle cx="15" cy="50" r="5" fill="#505166" />
    </svg>
  );
}
